import { useContext, useEffect } from "react";
import { AdvancedSearchContext } from "~/providers/AdvancedSearchProvider";

import FullBlankPage from "~/layouts/FullBlankPage";
import SearchTypeTabs from "~/features/SearchV3/components/SearchForm/SearchTypeTabs";
import SearchBarLabel from "~/features/SearchV3/components/SearchForm/SearchBarLabel";

import SearchDialogModal from "~/features/SearchV3/components/SearchDialog/SearchDialogModal";
import SearchDialogForm from "../SearchV3/components/SearchDialog/SearchDialogForm";

import useSolrMetaData from "~/features/SearchV3/hooks/useSolrMetaData";
import useInit from "../SearchV3/hooks/useInit";

import Logo from "~/assets/logo-trans-v3.png";
import RIGDialog from "~/features/ReaderIntelligenceGuide/RIGDialog";
import { useFiltersStore } from "~/stores/filters/useFilterStore";
import { FilterActions } from "~/types/actions.enum";

const SearchPanel = () => {
    const { isModalOpen } = useSolrMetaData();
    const REGION = import.meta.env.VITE_REGION;
    const showRIG = REGION === "us";

    const { resetFilters } = useContext(AdvancedSearchContext);

    // Store methods
    const dispatch = useFiltersStore(state => state.dispatch);

    useInit();

    useEffect(() => {
        resetFilters();
        dispatch({ type: FilterActions.SET_YEAR_FILTERS, payload: [] });
    }, []);

    return (
        <>
            <FullBlankPage>
                <div className="flex flex-col gap-6 w-[54.375rem] max-w-full mx-16 my-auto pt-40 z-[1] mx-auto">
                    <img className="w-56 h-16 mx-auto" src={Logo} alt="Explore Logo" />

                    <div className="relative w-full flex items-center gap-y-4 flex-col">
                        <SearchTypeTabs />
                        <SearchBarLabel />
                    </div>
                </div>

                {/** V3 Search pop-up modal */}
                <SearchDialogModal open={isModalOpen}>
                    <SearchDialogForm />
                </SearchDialogModal>
            </FullBlankPage>
            {showRIG && <RIGDialog defaultOpen={true} />}
        </>
    );
};

export default SearchPanel;
